const Footer = () => {
  return (
    <div className="w-full pb-2 dark:bg-[#343f4a]">
      <div
        className="flex flex-col w-full text-xs
        items-center justify-center
        text-center text-zinc-400 dark:text-white"
      >
        <div>Made with ❤️. Power by Huu Huy</div>
        <div>
          <p>Copyright © 2023</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
